import { currency } from "@bark/bark-core/src/helpers/number-formatting";
import { shouldShowLeadDetailsNewDesign } from "../lead_details_redesign";
import { tracking } from "@bark/bark-core";

export function GHGAndCreditStatus() {
    const Bark = window.Bark = window.Bark || {};
    const seller = Bark.seller = Bark.seller || {};
    const GHGCreditStatus = seller.GHGCreditStatus = seller.GHGCreditStatus || {};

    let CreditsBannerDispatcher;

    /**
     * @param {Number} projectId
     */
    GHGCreditStatus.render = (projectId) => {
        const project = Bark.seller.getProjectDataById(projectId)
        const container = $(`#ghg-on-leads-details`);

        container.show();

        if (CreditsBannerDispatcher && container.children().length) {
            Bark.seller.debug({
                ghgPostStarterPack: Bark.seller.show_ghg_post_starter_pack,
                nInvoices: Bark.seller.purchaser.nInvoices,
                spe: Bark.seller.is_starter_pack_eligible,
            });

            try {
                CreditsBannerDispatcher({
                    type: 'setCreditsRequired',
                    value: project.is_free ? 0 : project.credits_required
                });
                CreditsBannerDispatcher({
                    type: 'setIsStarterPackEligible',
                    value: Bark.seller.is_starter_pack_eligible
                });
				CreditsBannerDispatcher({
					type: 'setIsFreeWithSubscription',
					value: Boolean(project.is_free_with_subscription),
				});
				CreditsBannerDispatcher({
					type: 'setFreeLeadsRemaining',
					value: project.n_free_leads_remaining,
				});
                if (Bark.seller.purchaser.nInvoices > 1) {
                    Bark.seller.show_ghg_post_starter_pack = false;
                    CreditsBannerDispatcher({
                        type: 'setShowGHGHighlight',
                        value: false,
                    });
                }
            } catch (e) {}
        } else {
            if (window.SellerAppDashboard) {
                window.SellerAppDashboard.launchModule(
                    'ghg-on-leads-details',
                    'ghg-on-leads-details',
                    {
                        sellerProfileId: Number(Bark.seller.id),
                        projectId,
                        creditsRequired: project.is_free ? 0 : project.credits_required,
                        isStarterPackEligible: Bark.seller.is_starter_pack_eligible,
                        showGHGHighlight: Bark.seller.show_ghg_post_starter_pack,
                        isFreeWithSubscription: Boolean(project.is_free_with_subscription),
						freeLeadsRemaining: project.n_free_leads_remaining,
                        starterPackResponseCount: Bark.seller.starter_pack_size,
                        discountPercent: Bark.seller.starter_pack_discount_percent,
                        pricePerCredit: currency(project.price_per_credit),
                        isInLeadDetailsRedesignExp: !!shouldShowLeadDetailsNewDesign(),
                        onMount: dispatcher => {
                            CreditsBannerDispatcher = dispatcher;
                        },
                    },
                );
            } else {
                tracking(
                    'seller-leads-dashboard',
                    'Seller dashboard react app not loaded',
                );
            }
        }
    };

	GHGCreditStatus.updateFreeWithSubscriptionStatus = (isFreeWithSubscription, freeLeadsRemaining) => {
		CreditsBannerDispatcher?.({
			type: 'setIsFreeWithSubscription',
			value: isFreeWithSubscription,
		});
		CreditsBannerDispatcher?.({
			type: 'setFreeLeadsRemaining',
			value: freeLeadsRemaining,
		});
	};

	GHGCreditStatus.setCreditPrice = (creditsRequired) => {
		CreditsBannerDispatcher?.({
			type: 'setCreditsRequired',
			value: creditsRequired,
		});
	};
}
